/**
 * VersichererFristenPage - Administration › Versicherer-Fristen (P4-S7, Stefan 17.5).
 *
 * The per-tenant Fristen for the insurers' answer to a Versicherer-Benachrichtigung, next to the
 * Mahnwesen settings. Nav and page are gated on mahnwesen_config.manage, the key both api routes
 * need (the api is the hard line).
 */

import { AdminPageHeader } from '../AdminPageHeader';
import { ADMIN_PAGE_META } from '../adminNav';
import { VersichererFristenEinstellungen } from '../VersichererFristenEinstellungen';

const meta = ADMIN_PAGE_META['versicherer-fristen'];

export function VersichererFristenPage() {
  return (
    <div>
      <AdminPageHeader title={meta.title} description={meta.description} />
      <VersichererFristenEinstellungen />
    </div>
  );
}
